<style lang="scss" scoped="">
  @import '../../../assets/scss/mixins';

  .product-code-list {
    margin-top: 20px;
    text-align: center;
    border-collapse: collapse;
    font-size: 12px;

    td {
      height: 24px;
      border: 1px solid #dfe6ec;
    }

  }

  .t-head {
    background: #eef1f6;
    color: #1f2d3d;
    font-weight: bold;
  }

  .btn-group {
    margin-bottom: 30px;
    overflow: hidden;

    .download-icon {
      margin-top: 10px;
      cursor: pointer;

      &:hover a {
        color: $activeColor;
      }
    }
  }

  .empty-info {
    &.mini-empty-info {
      height: 60px;
    }
  }

  .qp-box {
    &.accessory {
      margin-bottom: 20px;
      border: 1px solid #eee;
      border-radius: 5px;
      padding: 0 20px 10px 20px;

      h2 {
        line-height: 20px;
        margin: 10px 0;
        padding: 0;
      }

      .accessory-item {
        margin-top: 10px;
      }
    }

    .accessory-list {
      .show-list {
        .list-item {
          .attachment-delete, .download-link {
            float: right;
            padding: 0 10px;
            color: #fff;
            font-size: 16px;
          }

          &:hover .attachment-delete {
            color: red;
          }

          &:hover .download-link {
            color: #1c8de0;
          }
        }
      }
    }
  }

  .order-list-body {
    .order-list-item {
      cursor: auto;
    }
  }

  .comment-box-submit--exception {
    border-top: 0;
    margin-top: 12px;
  }
</style>
<template>
  <div>
    <perm label="portal-order-download-code-file">
      <el-button :doing="xmlLoading" @click="downloadExcel" style="margin-left: 15px" type="primary">
        {{xmlLoading ? '正在下载' : '下载追溯码文件'}}
      </el-button>
    </perm>

    <h2 v-show="fileList.length">追溯码文件</h2>
    <review-file-list :fileList="fileList" :showDelBtn="false"/>
    <div>
      <div style="margin-bottom: 10px; margin-top: 20px;overflow: hidden">
       <span class="pull-right">
           <span class="btn-search-toggle open" v-show="showSearch">
              <single-input :showFocus="showSearch" placeholder="请输入追溯码搜索" v-model="filters.code"></single-input>
              <i @click.stop="showSearch=(!showSearch)" class="el-icon-t-search"></i>
           </span>
           <a @click.stop.prevent="showSearch=(!showSearch)" class="btn-circle" href="#" v-show="!showSearch">
              <i class="el-icon-t-search"></i>
           </a>
      </span>
      </div>
      <div class="order-list clearfix" v-loading="loadingData">

        <el-row class="order-list-header t-head" style="margin:0">
          <el-col :span="6">追溯码</el-col>
          <el-col :span="3">状态</el-col>
          <el-col :span="8">货品名称</el-col>
          <el-col :span="4">批号</el-col>
          <el-col :span="3">包装类型</el-col>
        </el-row>
        <el-row v-if="!traceCodes.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div class="order-list-body" v-else="">
          <div class="order-list-item order-list-item-bg" style="margin-left: 0;margin-right: 0"
               v-for="item in traceCodes">
            <el-row>
              <el-col :span="6" class="R">
                <span>{{ item.code }}</span>
              </el-col>
              <el-col :span="3">{{ statusType[item.status]}}</el-col>
              <el-col :span="8" class="pt">
                <span>{{ item.goodsName }}</span>
              </el-col>
              <el-col :span="4" class="pt">
                <span>{{ item.batchNumber }}</span>
              </el-col>
              <el-col :span="3" class="pt">
                <span>{{ packageType[item.packageScheme-1] }}</span>
              </el-col>
            </el-row>
          </div>
        </div>

      </div>
      <div class="text-center" v-show="(traceCodes.length || pager.currentPage !== 1) && !loadingData">
        <el-pagination :current-page="pager.currentPage" :page-size="pager.pageSize"
                       :page-sizes="[10,20,50,100]"
                       :total="pager.count" @current-change="handleCurrentChange"
                       @size-change="handleSizeChange"
                       layout="sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {http} from '@/resources';
  import utils from '@/tools/utils';
  import reviewFileList from '../review/review-file-list';

  export default {
    props: {
      currentOrder: {
        required: true,
        type: Object,
        default: function () {
          return {};
        }
      },
      index: {
        type: Number,
        default: -1
      },
      type: String,
      perm: String
    },
    components: {reviewFileList},
    data() {
      return {
        loadingData: false,
        showSearch: true,
        traceCodes: [],
        filters: {
          code: ''
        },
        statusType: ['未知', '流转中', '已使用', '异常'],
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: parseInt(window.localStorage.getItem('currentPageSize'), 10) || 10
        },
        packageType: utils.packageType,
        fileList: [],
        doing: false,
        xmlLoading: false
      };
    },
    watch: {
      index(val) {
        this.filters.code = '';
        this.fileList = [];
        if (val !== 9) return;
        this.getTraceCodes(1);
        this.queryFiles();
      },
      filters: {
        handler: function () {
          this.getTraceCodes(1);
        },
        deep: true
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pager.pageSize = val;
        window.localStorage.setItem('currentPageSize', val);
        this.getTraceCodes(1);
      },
      handleCurrentChange(val) {
        this.getTraceCodes(val);
      },
      queryFiles() {
        this.loading = true;
        this.$http.get(`/bsp-review/${this.currentOrder.id}/file`).then(res => {
          this.fileList = res.data;
        });
      },
      downloadExcel() {
        this.xmlLoading = true;
        let params = {
          sourceOrgId: this.currentOrder.type === '0' ? this.currentOrder.downstreamOrgId : this.currentOrder.upstreamOrgId,
          directOrgId: this.currentOrder.type === '0' ? this.currentOrder.upstreamOrgId : this.currentOrder.downstreamOrgId
        };
        this.$http.get(`bsp-order/${this.currentOrder.id}/trace-code/export`, {params}).then(res => {
          this.downloadFile(res.data.path);
        }).catch(error => {
          this.xmlLoading = false;
          this.$notify({
            duration: 2000,
            title: '无法下载',
            message: error.response && error.response.data && error.response.data.msg || '网络异常',
            type: 'error'
          });
        });
      },
      downloadFile(url) {
        this.$http({
          url: url,
          timeout: 1000000,
          responseType: 'blob',
          withCredentials: false
        }).then(res => {
          this.xmlLoading = false;
          let reg = /name=(.+?).xml/.exec(url);
          if (reg && reg[1]) {
            this.funDownload(res.data, reg[1]);
          } else {
            this.funDownload(res.data, '追溯码文件');
          }
        }).catch(() => {
          this.xmlLoading = false;
        });
      },
      funDownload: function (blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename);
        } else {
          const link = document.createElement('a');
          const body = document.querySelector('body');

          link.href = window.URL.createObjectURL(blob);
          link.download = filename;

          // fix Firefox
          link.style.display = 'none';
          body.appendChild(link);

          link.click();
          body.removeChild(link);

          window.URL.revokeObjectURL(link.href);
        }
      },
      getTraceCodes(pageNo) {
        this.pager.currentPage = pageNo;
        let params = Object.assign({
          pageNo: pageNo,
          pageSize: this.pager.pageSize,
          type: this.type,
          sourceOrgId: this.currentOrder.type === '0' ? this.currentOrder.downstreamOrgId : this.currentOrder.upstreamOrgId,
          directOrgId: this.currentOrder.type === '0' ? this.currentOrder.upstreamOrgId : this.currentOrder.downstreamOrgId
        }, this.filters);
        this.loadingData = true;
        http.get(`/bsp-review/${this.currentOrder.orderNo}/trace-code`, {params}).then(res => {
          this.traceCodes = res.data.list;
          // 设置分页数
          this.pager.count = this.pager.currentPage * this.pager.pageSize + (this.traceCodes.length === this.pager.pageSize ? 1 : 0);
          this.loadingData = false;
        });
      }
    }
  };
</script>
